export default "__VITE_ASSET__1d8c3d4c__"